import { TICKET_STATE_LABELS, type TicketState } from '@easyhelp/shared';
import Chip from '@mui/material/Chip';
import type { SxProps, Theme } from '@mui/material/styles';

/** Colori dei sei stati (DEC-002): i quattro del prototipo più Chiuso e Scartato, neutri. */
const STATE_STYLES: Record<TicketState, SxProps<Theme>> = {
  nuovo: { bgcolor: 'primary.lighter', color: 'primary.darker' },
  in_lavorazione: { bgcolor: 'warning.lighter', color: 'warning.dark' },
  in_attesa_utente: { bgcolor: 'grey.200', color: 'grey.800' },
  risolto: { bgcolor: 'secondary.lighter', color: 'secondary.darker' },
  chiuso: { bgcolor: 'grey.400', color: 'grey.900' },
  scartato: { bgcolor: 'common.white', color: 'grey.700', border: 1, borderColor: 'grey.600' },
};

/** Stato del ticket con l'etichetta della console (DEC-002). */
export function StateChip({ state }: { state: TicketState }) {
  return <Chip size="small" label={TICKET_STATE_LABELS[state]} sx={STATE_STYLES[state]} />;
}
